import { Link } from "react-router-dom";
import VerdictBadge from "@/components/base/VerdictBadge";
import type { Verdict } from "@/mocks/types";

interface CaseItem {
  code: string;
  id: string;
  category: string;
  verdict: Verdict;
  claim: string;
  fact: string;
  why: string;
}

const cases: CaseItem[] = [
  {
    code: "S-260910-01",
    id: "s260910-01",
    category: "社会民生",
    verdict: "confirmed",
    claim: "网传门店后厨使用过期食材，视频是拼接的、不能作数。",
    fact: "九段视频拍摄设备一致，台面划痕、排风口与值日表均可交叉对应。",
    why: "判定为连续拍摄而非拼接，且进货单据与标签日期存在时间差，因此核心事实成立。",
  },
  {
    code: "S-260904-03",
    id: "s260904-03",
    category: "社会民生",
    verdict: "refuted",
    claim: "公益活动善款去向不明，账目对不上。",
    fact: "完整收支表含募集、执行、结余三列，票据与回单逐笔对应。",
    why: "质疑文章把表头裁掉后只看两列数字，导致出现所谓『差距』，属误读而非事实。",
  },
  {
    code: "S-260901-05",
    id: "s260901-05",
    category: "健康生活",
    verdict: "partial",
    claim: "检测结果严重超标，产品已经不能吃了。",
    fact: "同批次留样复检仅略高于企业内控标准，与网传数值不在同一量级。",
    why: "确实存在高于内控指标的情形，但『超标』的性质与量级都被明显夸大。",
  },
];

export default function CaseStudies() {
  return (
    <div className="space-y-5">
      {cases.map((item) => (
        <article key={item.id} className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <header className="flex flex-wrap items-center gap-3 border-b border-background-200 bg-background-100 px-5 py-3.5">
            <VerdictBadge verdict={item.verdict} size="sm" />
            <span className="font-label text-[11px] text-foreground-500">{item.code}</span>
            <span className="font-label text-[11px] text-foreground-500">{item.category}</span>
          </header>
          <div className="grid grid-cols-1 divide-y divide-background-200 md:grid-cols-2 md:divide-x md:divide-y-0">
            <div className="p-5">
              <p className="font-label text-[11px] uppercase tracking-widest text-foreground-400">流传说法</p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.claim}</p>
            </div>
            <div className="p-5">
              <p className="font-label text-[11px] uppercase tracking-widest text-primary-500">核验事实</p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-900">{item.fact}</p>
            </div>
          </div>
          <div className="border-t border-background-200 bg-secondary-50 px-5 py-4">
            <p className="text-[13px] leading-relaxed text-secondary-900">
              <span className="font-heading font-bold">辨析要点：</span>
              {item.why}
            </p>
            <Link
              to={`/scoop/${item.id}`}
              className="mt-3 inline-flex items-center gap-1 font-label text-[12px] text-primary-600 transition-colors hover:text-primary-700"
            >
              查看完整档案
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </article>
      ))}
    </div>
  );
}